<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="课程类型">
        <el-select v-model="search.type" placeholder="课程类型">
          <el-option label="全部" value="" />
          <el-option v-for="item in courseType" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="课程状态">
        <el-select v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in courseStatus" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.search" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="postOnlineCourse('')">
        <svg-icon icon-class="public" />
        立即发布
      </el-button>
      <el-button size="small" type="primary" @click="exportClassList()">
        <svg-icon icon-class="up" />
        导出列表
      </el-button>
      <el-button size="small" type="primary" @click="openImportDialog()">
        <svg-icon icon-class="down" />
        导入列表
      </el-button>
    </div>
    <div ref="tableBox" class="activity-table">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.course.postCourseList" style="width: 100%" :deal-data="dealData" :cell-mouse-enter="cellMouseEnter" :cell-mouse-leave="cellMouseLeave" @selection-change="selectionItemChange">
        <el-table-column type="selection" width="55" fixed :selectable="(row) => row.status == 1" />
        <el-table-column prop="id" label="课程ID" />
        <el-table-column prop="sort" label="课程序号">
          <template v-slot="{row,$index}">
            <span style="margin-right: 16px;">{{ row.sort }}</span>
            <el-popover v-if="row.showPopover" :append-to-body="false" :placement="$index ===size-1? 'top-start' :'bottom-start'" trigger="click">
              <div style="display: flex; white-space: nowrap;line-height: 30px;align-items: center;">
                <el-input v-model.number="row.tempSort" type="number" style="width: 60px; margin-right: 15px;" @input="value => row.tempSort = parseInt(value)" />
                <span style="color: #0085D0; margin-right: 10px; cursor: pointer;" @click="handleSortClass(row)">保存</span>
                <span style="color: #0085D0; cursor: pointer;" @click="handleCloseSort(row)">取消</span>
              </div>
              <i slot="reference" class="el-icon-edit" style="cursor: pointer;" />
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="courseTypeName" label="课程类型">
          <template slot-scope="scope">
            <div class="activity-type activity-type-common">{{ courseType.find(item => scope.row.courseTypeId == item.id).name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="课程标题" />
        <el-table-column prop="tagList" label="课程标签">
          <template slot-scope="scope">
            {{ Array.isArray(scope.row.tagList) ? scope.row.tagList.reduce((init, item) => {
              init.push(item.tagName)
              return init
            }, []).join('/') : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="课程状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="courseStatus[scope.row.status].color" size="mini">{{ courseStatus[scope.row.status].value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="onlineTime" label="发布时间" />

        <el-table-column fixed="right" width="250px" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" class="link-color" @click="edit(scope.row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="copy(scope.row)">复制</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(scope.row)">删除</el-button>
            <el-button v-if="scope.row.status === 1" size="small" type="text" class="link-color" @click="postOnlineCourse(scope.row.id)">发布</el-button>
            <el-button v-if="scope.row.status === 0" size="small" type="text" class="link-color" @click="postOfflineCourse(scope.row.id)">下架</el-button>
            <!-- <el-button v-if="scope.row.status === 0 && scope.row.isTop === 0" size="small" type="text" class="link-color" @click="postStickyCourse(scope.row.id)">置顶</el-button>
            <el-button v-if="scope.row.status === 0 && scope.row.isTop === 1" size="small" type="text" class="link-color" @click="postUnStickyCourse(scope.row.id)">取消置顶</el-button> -->
          </template>
        </el-table-column>
      </tableList>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
      <el-dialog v-if="importDialogShow" :visible="importDialogShow" title="导入课程列表" custom-class="share-wrapper" @close="handleCloseImport">
        <div class="upload-wrap">
          <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
          <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
            <div>
              <div style="height:50px;">
                <svg-icon icon-class="xls" style="width: 50px; height: 50px;" />
              </div>
              <el-button v-if="!classExcel" size="small">选择文件</el-button>
              <template v-else>
                <div class="file">{{ classExcel.name }}</div>
                <el-button size="small">重新选择</el-button>
              </template>
            </div>
          </el-upload>

        </div>
        <div class="flex btns">
          <el-button type="info" @click="handleCloseImport">取消</el-button>
          <el-button type="primary" @click="uploadSubmit">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import { getFileType } from '@/common/js/util';
export default {
  components: { tableList, Dialog },
  data() {
    const courseStatus = [
      { id: 0, value: '发布', color: 'success' },
      { id: 1, value: '草稿', color: 'warning' },
    ];
    return {
      enter: -1,
      courseStatus,
      courseType: [],
      search: {
        type: '',
        status: '',
        search: '',
      },
      selectionId: [],
      formDialogShow: false,
      importDialogShow: false,
      currentID: -1,
      information: {},
      classExcel: null, // 课程列表文件
    };
  },
  beforeRouteLeave(to, from, next) {
    const list = ['/class/edit', '/class/add'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.search = {
        type: '',
        status: '',
        search: '',
      };
    }
    next();
  },
  computed: {
    // 教练级别
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((init, item) => {
        if (!init.includes(item.level) && item.level) init.push(item.level);
        return init;
      }, []);
    },
    // 当前表格有多少行
    size() {
      const list = this.$refs['multipleTable'].getData();
      return list.length || 0;
    },
  },
  activated() {
    this.enter += 1;
    if (this.enter) {
      this.classExcel = null;
      this.searchSubmit();
    }
  },

  mounted() {
    this.getCourseTypeList();
  },
  methods: {
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        return;
      }
      this.classExcel = file.raw;
    },
    // 保存课程
    uploadSubmit() {
      if (!this.classExcel) {
        this.$message.warning('请先选择文件');
        return;
      }
      this.$Api.course.postImportCourse(this.classExcel).then(res => {
        this.$message.success('导入成功');
        this.$refs['multipleTable'].handleCurrentChange(1);
        this.handleCloseImport();
      });
    },
    handleCloseImport() {
      this.classExcel = null;
      this.importDialogShow = false;
    },
    openImportDialog() {
      this.importDialogShow = true;
    },
    exportClassList() {
      this.$Api.course.getExportCourse().then(res => {
        this.$message.success('导出成功');
      });
    },
    cellMouseEnter(row, column, cell, event) {
      // 发布状态才允许修改序号
      row.status === 0 ? row.showPopover = true : null;
    },
    cellMouseLeave(row, column, cell, event) {
      row.showPopover = false;
    },
    dealData(data) {
      return data.map((item) => {
        item.showPopover = false;
        item.tempSort = item.sort || 1;
        return item;
      });
    },
    // 课程排序
    handleSortClass(row) {
      if (row.sort === row.tempSort) {
        this.closeSort();
        return;
      }
      if (row.tempSort <= 0 || isNaN(row.tempSort)) {
        this.$message.error('排序数值大于等于1');
        return;
      }
      if (row.tempSort >= 0 && row.id) {
        const current = this.$refs['multipleTable'].$data.paginationParams.current;
        this.$Api.course.postSortCourse({
          id: row.id,
          sort: row.tempSort,
          current: current || 1,
          limit: this.$refs['multipleTable'].$data.paginationParams.size || 10,
        }).then(res => {
          if (res) {
            this.$message.success('序号修改成功');
            this.$refs['multipleTable'].handleCurrentChange(res);
          }
        });
      }
      this.closeSort();
    },
    handleCloseSort(row) {
      this.closeSort();
      row.tempSort = row.sort;
    },
    closeSort() {
      document.body.click();
    },
    add() {
      this.$router.push({ path: '/class/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑课程ID为“${row.id}”的数据项？`,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该课程，请确认是否删除',
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.course.deleteCourse([this.currentID], { hideMessage: true }).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/class/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/class/edit', query: { id: this.currentID } });
      }
    },
    // 获取课程类别
    getCourseTypeList() {
      this.$Api.course.getCourseTypeList().then(res => {
        this.courseType = res;
      });
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 删除课程
    deleteCourse() {
      this.$Api.course.deleteCourse([this.currentID]).then(() => {
        this.dialogVisible = false;
        this.$message.success('删除成功');
        this.searchSubmit();
      });
    },
    // 上架课程
    postOnlineCourse(id) {
      this.$Api.course.postOnlineCourse(id ? [id] : this.selectionId).then(() => {
        this.$message.success('上架成功');
        this.searchSubmit();
      });
    },
    // 下架课程
    postOfflineCourse(id) {
      this.$Api.course.postOfflineCourse([id]).then(() => {
        this.$message.success('下架成功');
        this.searchSubmit();
      });
    },
    // 置顶课程
    postStickyCourse(id) {
      this.$Api.course.postStickyCourse([id]).then(() => {
        this.$message.success('置顶成功');
        this.searchSubmit();
      });
    },
    // 取消置顶课程
    postUnStickyCourse(id) {
      this.$Api.course.postUnStickyCourse([id]).then(() => {
        this.$message.success('取消置顶成功');
        this.searchSubmit();
      });
    },
    // 当选择项发生变化时会触发该事件
    selectionItemChange(selection) {
      this.selectionId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 538px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>
